module.exports = __webpack_public_path__ + "media/images/adobe-pdf-icon-6b0ddade4026883779fce899e57f5206.png";